import type { ValueFormatterParams } from "ag-grid-community";

import { formatPercentage } from "../utils/grid-helpers";

export const PercentageCellRenderer = (params: ValueFormatterParams<number>) => {
  const raw = params.value as number | undefined;
  const percent = typeof raw === "number" ? raw : 0;
  return formatPercentage(percent, 2);
};
